import { news_action } from '@lc/action/cardType/News';
import { NewsMeta } from '@lc/card/meta/NewsMeta';
import { createCardNewsVerbose } from '@lc/interface/card/news/factory';
import { GameState } from '@lc/interface/gameState/types';

export const NewsVerbose = [
	createCardNewsVerbose(NewsMeta[0], (gameState: GameState) =>
		news_action.oilSpill(gameState)
	),
	createCardNewsVerbose(NewsMeta[1], (gameState: GameState) =>
		news_action.artOfSteal(gameState)
	),
	createCardNewsVerbose(NewsMeta[2], (gameState: GameState) =>
		news_action.rechargeAllBatteriesMinusCarbon(gameState)
	),
	createCardNewsVerbose(NewsMeta[3], (gameState: GameState) =>
		news_action.nannyState(gameState)
	),
	createCardNewsVerbose(NewsMeta[4], (gameState: GameState) =>
		news_action.superPac(gameState)
	),
	createCardNewsVerbose(NewsMeta[5], (gameState: GameState) =>
		news_action.oilThieves(gameState)
	),
	createCardNewsVerbose(NewsMeta[6], (gameState: GameState) =>
		news_action.electricCarDead(gameState)
	),
	createCardNewsVerbose(NewsMeta[7], (_gameState: GameState) => ({})),
	createCardNewsVerbose(NewsMeta[8], (gameState: GameState) =>
		news_action.badPublicity(gameState)
	),
	createCardNewsVerbose(NewsMeta[9], (gameState: GameState) =>
		news_action.noAction(gameState)
	),
	createCardNewsVerbose(NewsMeta[10], (gameState: GameState) =>
		news_action.misinformationAge(gameState)
	),
	createCardNewsVerbose(NewsMeta[11], (gameState: GameState) =>
		news_action.glacierNational(gameState)
	),
	createCardNewsVerbose(NewsMeta[12], (gameState: GameState) =>
		news_action.greatLandfills(gameState)
	),
	createCardNewsVerbose(NewsMeta[13], (gameState: GameState) =>
		news_action.fracking(gameState)
	),
	createCardNewsVerbose(NewsMeta[14], (gameState: GameState) =>
		news_action.noAction(gameState)
	),
	createCardNewsVerbose(NewsMeta[15], (gameState: GameState) =>
		news_action.freeChargedBattery(gameState)
	),
	createCardNewsVerbose(NewsMeta[16], (gameState: GameState) =>
		news_action.genderReveal(gameState)
	),
	createCardNewsVerbose(NewsMeta[17], (gameState: GameState) =>
		news_action.noAction(gameState)
	),
	createCardNewsVerbose(NewsMeta[18], (gameState: GameState) =>
		news_action.gluten(gameState)
	),
	createCardNewsVerbose(NewsMeta[19], (gameState: GameState) =>
		news_action.rechargeAllBatteries(gameState)
	),
	createCardNewsVerbose(NewsMeta[20], (gameState: GameState) =>
		news_action.noAction(gameState)
	),
	createCardNewsVerbose(NewsMeta[21], (gameState: GameState) =>
		news_action.dadsAgainstElectric(gameState)
	),
	createCardNewsVerbose(NewsMeta[22], (gameState: GameState) =>
		news_action.noAction(gameState)
	),
	createCardNewsVerbose(NewsMeta[23], (gameState: GameState) =>
		news_action.tireFire(gameState)
	),
	createCardNewsVerbose(NewsMeta[24], (gameState: GameState) =>
		news_action.spinClass(gameState)
	),
	createCardNewsVerbose(NewsMeta[25], (gameState: GameState) =>
		news_action.proTobacco(gameState)
	),
	createCardNewsVerbose(NewsMeta[26], (gameState: GameState) =>
		news_action.cryptocurrencyMine(gameState)
	),
	createCardNewsVerbose(NewsMeta[27], (gameState: GameState) =>
		news_action.commonCold(gameState)
	),
	createCardNewsVerbose(NewsMeta[28], (gameState: GameState) =>
		news_action.gasGiant(gameState)
	),
	createCardNewsVerbose(NewsMeta[29], (gameState: GameState) =>
		news_action.noAction(gameState)
	),
	createCardNewsVerbose(NewsMeta[30], (gameState: GameState) =>
		news_action.lastWhale(gameState)
	),
	createCardNewsVerbose(NewsMeta[31], (gameState: GameState) =>
		news_action.chemtrails(gameState)
	),
	createCardNewsVerbose(NewsMeta[32], (gameState: GameState) =>
		news_action.hottestYear(gameState)
	),
	createCardNewsVerbose(NewsMeta[33], (gameState: GameState) =>
		news_action.greatPacificGarbagePatch(gameState)
	),
	createCardNewsVerbose(NewsMeta[34], (gameState: GameState) =>
		news_action.insiderTrading(gameState)
	),
	createCardNewsVerbose(NewsMeta[35], (gameState: GameState) =>
		news_action.darkSideOfMoon(gameState)
	),
	createCardNewsVerbose(NewsMeta[36], (gameState: GameState) =>
		news_action.ancientAlien(gameState)
	),
	createCardNewsVerbose(NewsMeta[37], (gameState: GameState) =>
		news_action.netMetering(gameState)
	),
	createCardNewsVerbose(NewsMeta[38], (gameState: GameState) =>
		news_action.findingNucleus(gameState)
	),
	createCardNewsVerbose(NewsMeta[39], (gameState: GameState) =>
		news_action.zodiacKiller(gameState)
	),
];
